require('./specialCoveragesModal.scss');
require('./specialCoveragesModal.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@utilities
const { toFirstUppercase } = require('utilities/stringHelper');

//@commons
const OKModal = require('components/commons/OKModal/OKModal');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

//@components
const FormInput = require('./formInput/formInput');
const CivilResponsability = require('./civilResponsability/civilResponsability');

//@Contants
const {
    COVERAGES,
    SPECIAL_COVERAGES_MODAL: { DOGS_INCLUSION_YES, DOGS_INCLUSION },
    PLANS: { BASIC, MEDIUM, HIGH }
} = require('../../../insuranceConstants/insuranceRequestHome');
const { THIRD_STEP } = require('constants/index');
const poeditorPrefix = `insuranceRequestHomeCC-insuranceRequestHomeCC_specialCoveragesModal`;

class SpecialCoveragesModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showDogsInputError: false
        }

        this.handleModalApply = this.handleModalApply.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
    }

    getSelectedPlanUpperCase() {
        const { immInsuranceWizardStep3 } = this.props;

        return immInsuranceWizardStep3.get('insurancePlan').toUpperCase();
    }

    getCoverage(coverageId) {
        const { immInsuranceWizardStep3 } = this.props;

        const selectedPlan = this.getSelectedPlanUpperCase();

        return immInsuranceWizardStep3.getIn(['coveragePlanModal', selectedPlan, coverageId]);
    }

    getCoverageValue(coverageId) {
        const coverage = this.getCoverage(coverageId);
        const defaultValue = parseInt(coverage.get('defaultValue'));
        const currentValue = coverage.get('currentValue');

        return currentValue || defaultValue;
    }

    handleModalApply() {
        const { getQuotationData, onHandleToggle, setData, immInsuranceWizardStep3} = this.props;

        const dogsInclusionValue = this.getCoverageValue(DOGS_INCLUSION);
        const dangerousDogs = this.getCoverageValue(COVERAGES.DANGEROUS_DOGS_NUMBER);
        const showDogsInput = dogsInclusionValue === DOGS_INCLUSION_YES;
        const isQuotationDataChanged = immInsuranceWizardStep3.get("isQuotationDataChanged");

        if (!isQuotationDataChanged) {
            setData(THIRD_STEP, {
                coveragePlanDefault: immInsuranceWizardStep3.get("coveragePlanModal"),
                quotationDataDefault: immInsuranceWizardStep3.get("quotationData"),
                isQuotationDataChanged: true
            });
        }

        if (showDogsInput && !dangerousDogs) {
            this.setState({ showDogsInputError: true });
        } else {
            this.setState({ showDogsInputError: false });
            getQuotationData();
            onHandleToggle();
        }
    }

    hasPropChanged(coverageId, newValue, zeroIsAccepted) {
        const coverage = this.getCoverage(coverageId);
        const defaultValue = parseInt(coverage.get('defaultValue'));
        const newValueParse = parseInt(newValue);
        return newValueParse || (zeroIsAccepted && newValueParse === 0)  ? defaultValue !== newValueParse : false;
    }

    handleAmountChange(coverageId, zeroIsAccepted = false) {
        const { setData } = this.props;

        const plan = this.getSelectedPlanUpperCase();

        return value => {
            const hasPropChanged = this.hasPropChanged(coverageId, value, zeroIsAccepted);

            setData(THIRD_STEP, {
                coveragePlanModal: {
                    [plan]: {
                        [coverageId]: {
                            currentValue: value,
                            hasChanged: hasPropChanged
                        }
                    }
                }
            });
        }
    }

    buildMandatoryReading() {
        const message = `${poeditorPrefix}MandatoryReading`;

        return (
            <BlockInfo
                extraClass={'special-coverages-modal__block-info'}>
                {formatText(message)}
            </BlockInfo>
        )
    }

    buildSelectedPlanSection() {
        const { immInsuranceWizardStep3 } = this.props;

        const selectedPlan = toFirstUppercase(immInsuranceWizardStep3.get('insurancePlan'));

        return (
            <div className="special-coverages-modal__selected-plan">
                <span className="special-coverages-modal__icon-checked"></span>
                <FormattedText value={`${poeditorPrefix}SelectedPlan`} />
                <span className="special-coverages-modal__selected-plan-bold">
                    <FormattedText value={`insuranceRequestHome-insuranceType${selectedPlan}`} />
                </span>
            </div>
        );
    }

    buildElectricalDamageInput() {
        const electricalDamageAmount = this.getCoverageValue(COVERAGES.ELECTRICAL_DAMAGE);

        return (
            <FormInput
                title={`${poeditorPrefix}ElectricalDamage`}
                subtitle={`${poeditorPrefix}InsuredCapital`}
                minValue={300}
                maxValue={6000}
                tooltipContent={`${poeditorPrefix}ElectricalDamageTooltip`}
                value={electricalDamageAmount}
                handleAmountChange={this.handleAmountChange(COVERAGES.ELECTRICAL_DAMAGE)} />
        );
    }

    checkIfCoverageExist(planData, coverage) {
        return planData && planData.some(coveragePlan => coveragePlan.get('name') === coverage)
    }

    checkIfCoverageIsNull(planData, coverage) {
        let isCoverageNull = false;
        planData.map(coverageplan => {
            if (coverageplan.get('name') === coverage) {
                isCoverageNull = coverageplan.get('defaultValue') === null ? true : false;
            }
        })
        return isCoverageNull
    }

    setDisableInputStatus(coverName, coverageStole = false) {
        const { immInsuranceWizardStep3 } = this.props;

        const plans = [BASIC, MEDIUM, HIGH];
        let inputsDisabled = {};

        plans.map(plan => {
            const planData = immInsuranceWizardStep3.getIn(['coveragesAndPlansData', plan]);
            if (!coverageStole) {
                inputsDisabled[plan] = this.checkIfCoverageIsNull(planData, coverName)
            } else if (this.checkIfCoverageExist(planData, 'STOLE')) {
                planData.map((coverage) => {
                    if (coverage.get('name') === 'STOLE') {
                        const stoleCoverageChildren = coverage.get('children');
                        inputsDisabled[plan] = this.checkIfCoverageIsNull(stoleCoverageChildren, coverName)
                    }
                })
            } else {
                inputsDisabled[plan] = true;
            }
        });

        return inputsDisabled;
    }

    buildCosmeticDamageInput() {
        const { immInsuranceWizardStep3 } = this.props;

        const insurancePlan = immInsuranceWizardStep3.get('insurancePlan');
        const disabledInputsStatus = this.setDisableInputStatus('AESTHETIC_DAMAGE');
        const cosmeticDamageInputIsDisabled = disabledInputsStatus[insurancePlan];
        const cosmeticDamageAmount = this.getCoverageValue(COVERAGES.AESTHETIC_DAMAGE);

        return (
            <FormInput
                title={`${poeditorPrefix}CosmeticDamage`}
                subtitle={`${poeditorPrefix}CosmeticDamage`}
                minValue={1000}
                maxValue={5000}
                tooltipContent={`${poeditorPrefix}CosmeticDamageTooltip`}
                value={cosmeticDamageAmount}
                disabled={cosmeticDamageInputIsDisabled}
                plansDisableStatus={disabledInputsStatus}
                handleAmountChange={this.handleAmountChange(COVERAGES.AESTHETIC_DAMAGE)} />
        );
    }

    buildImpairmentHousing() {
        const { immInsuranceWizardStep3 } = this.props;

        const insurancePlan = immInsuranceWizardStep3.get('insurancePlan');
        const disabledInputsStatus = this.setDisableInputStatus('IMPAIRMENTS_HOUSING', true);
        const impairmentHousingIsDisabled = disabledInputsStatus[insurancePlan];
        const flawAmount = this.getCoverageValue(COVERAGES.IMPAIRMENTS_HOUSING);

        return (
            <div className="col-xs-5">
                <FormInput
                    title={`${poeditorPrefix}Robbery`}
                    subtitle={`${poeditorPrefix}FlawAmount`}
                    minValue={500}
                    maxValue={6000}
                    tooltipContent={`${poeditorPrefix}RobberyTooltip`}
                    value={flawAmount}
                    disabled={impairmentHousingIsDisabled}
                    plansDisableStatus={disabledInputsStatus}
                    handleAmountChange={this.handleAmountChange(COVERAGES.IMPAIRMENTS_HOUSING)} />
            </div>
        )
    }

    buildThefMoney() {
        const { immInsuranceWizardStep3 } = this.props;

        const insurancePlan = immInsuranceWizardStep3.get('insurancePlan');
        const disabledInputsStatus = this.setDisableInputStatus('THEFT_MONEY', true);
        const thefMoneyIsDisabled = disabledInputsStatus[insurancePlan];
        const cashAmount = parseInt(this.getCoverageValue(COVERAGES.THEFT_MONEY));
        const showThefMoney = !disabledInputsStatus[BASIC] || !disabledInputsStatus[MEDIUM] || !disabledInputsStatus[HIGH];
        const zeroIsAccepted = parseInt(this.getCoverage(COVERAGES.THEFT_MONEY).get('defaultValue')) === 0;
        const minValue = cashAmount === 0 && zeroIsAccepted ? 0 : 150;
        const value = !zeroIsAccepted && cashAmount === 0 ? minValue : cashAmount;
        return showThefMoney ? (
            <div className="col-xs-7">
                <FormInput
                    subtitle={`${poeditorPrefix}CashAmount`}
                    minValueLabel={150}
                    minValue={minValue}
                    maxValue={600}
                    tooltipLabel={false}
                    value={value}
                    disabled={thefMoneyIsDisabled}
                    plansDisableStatus={disabledInputsStatus}
                    zeroIsAccepted={zeroIsAccepted}
                    handleAmountChange={this.handleAmountChange(COVERAGES.THEFT_MONEY, zeroIsAccepted)} />
            </div>
        ) : null;
    }

    buildContent() {
        const { showDogsInputError } = this.state;
        const { immInsuranceWizardStep3, setData } = this.props;

        const mandatoryReading = this.buildMandatoryReading();
        const selectedPlanSection = this.buildSelectedPlanSection();
        const electricalDamageInput = this.buildElectricalDamageInput();
        const cosmeticDamageInput = this.buildCosmeticDamageInput();
        const impairmentHousing = this.buildImpairmentHousing();
        const thefMoney = this.buildThefMoney();

        return (
            <div className="special-coverages-modal__content container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        {mandatoryReading}
                        {selectedPlanSection}
                        <div className="row">
                            <div className="col-xs-5">
                                {electricalDamageInput}
                                {cosmeticDamageInput}
                            </div>
                            <div className="col-xs-7">
                                <CivilResponsability
                                    immInsuranceWizardStep3={immInsuranceWizardStep3}
                                    setData={setData}
                                    showDogsInputError={showDogsInputError} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="row">
                                    {impairmentHousing}
                                    {thefMoney}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    hasAnyInputChanged() {
        const { immInsuranceWizardStep3 } = this.props;

        const selectedPlan = this.getSelectedPlanUpperCase();
        const planCoverages = immInsuranceWizardStep3.getIn(['coveragePlanModal', selectedPlan]);

        const anyChanged = planCoverages.reduce((accumulator, coverage) => {
            return accumulator || coverage.get('hasChanged')
        }, false);

        return anyChanged;
    }

    render() {
        const { onHandleToggle, showModal } = this.props;

        const content = this.buildContent();
        const hasAnyInputChanged = this.hasAnyInputChanged();

        return (
            <OKModal
                content={content}
                contentOverflow="auto"
                footerType="navigation"
                isOpen={showModal}
                onCloseCallback={onHandleToggle}
                onPrimaryButtonClick={this.handleModalApply}
                onSecondaryButtonClick={onHandleToggle}
                primaryButtonDisabled={!hasAnyInputChanged}
                primaryButtonText={"common-apply"}
                secondaryButtonText={"common-cancel"}
                shouldCloseOnOverlayClick={true}
                size="large"
                title={formatText(`${poeditorPrefix}Title`)}
            />
        );
    }
}

SpecialCoveragesModal.propTypes = {
    getQuotationData: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    onHandleToggle: PropTypes.func.isRequired,
    immInsuranceWizardStep3: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
};

module.exports = SpecialCoveragesModal;
